import React from "react";

/**
 * [PONPISH] 상품 수령 가이드 (React + TailwindCSS)
 * - Tailwind 설정이 된 환경을 전제로 작성합니다.
 * - 좌측 고정 목차(>=lg), 모바일 접이식 목차, 섹션 앵커 스크롤, 가독성 위주의 레이아웃 구성.
 */

const sections = [
  {
    id: "section1",
    title: "섹션 1",
    body: (
      <p>내용이 들어갈 자리입니다.</p>
    ),
  },
  {
    id: "section2",
    title: "섹션 2",
    body: (
      <p>내용이 들어갈 자리입니다.</p>
    ),
  },
  {
    id: "section3",
    title: "섹션 3",
    body: (
      <p>내용이 들어갈 자리입니다.</p>
    ),
  },
];

function Toc({ sections }: { sections: { id: string; title: string }[] }) {
  return (
    <nav className="hidden lg:block sticky top-24 h-[calc(100vh-6rem)] overflow-auto pr-6">
      <h2 className="text-sm font-semibold text-gray-600 mb-3">목차</h2>
      <ol className="space-y-2 text-sm">
        {sections.map((s) => (
          <li key={s.id}>
            <a
              href={`#${s.id}`}
              className="block rounded-md px-2 py-1 hover:bg-gray-100 transition"
            >
              {s.title}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}

function MobileToc({ sections }: { sections: { id: string; title: string }[] }) {
  return (
    <details className="lg:hidden mb-4 rounded-xl border bg-white shadow-sm">
      <summary className="cursor-pointer select-none px-4 py-3 text-sm font-medium">목차 열기</summary>
      <div className="border-t px-4 py-3">
        <ol className="space-y-2 text-sm">
          {sections.map((s) => (
            <li key={s.id}>
              <a href={`#${s.id}`} className="block rounded-md px-2 py-1 hover:bg-gray-100">
                {s.title}
              </a>
            </li>
          ))}
        </ol>
      </div>
    </details>
  );
}

export default function PonpishProductReceiptGuidePage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* 컨테이너 */}
      <main className="mx-auto max-w-6xl px-2 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-[260px,1fr] gap-8">
          <Toc sections={sections.map(({ id, title }) => ({ id, title }))} />

          <article className="min-w-0">
            <div className="rounded-2xl border bg-white p-6 shadow-sm">
              <h1 className="text-2xl font-bold tracking-tight">[PONPISH] 상품 수령 가이드</h1>

              {/* <MobileToc sections={sections.map(({ id, title }) => ({ id, title }))} /> */}

              {/* <div className="divide-y">
                {sections.map((s) => (
                  <section id={s.id} key={s.id} className="scroll-mt-24 py-6">
                    <h2 className="text-lg font-semibold mb-3">{s.title}</h2>
                    <div className="space-y-3 leading-7 text-gray-800">{s.body}</div>
                  </section>
                ))}
              </div> */}

              <footer className="mt-6 border-t pt-4 text-xs text-gray-500">
                법령·서비스 변경에 따라 본 문서는 갱신될 수 있습니다.
              </footer>
            </div>
          </article>
        </div>
      </main>
    </div>
  );
}
